<template>
	<router-view />
</template>

<style>
	/**
		* 全局样式初始化
		*/
	HTML,
	body,
	div,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	ul,
	ol,
	dl,
	li,
	dt,
	dd,
	p,
	blockquote,
	pre,
	form,
	fieldset,
	table,
	th,
	td {
		border: none;
		font-family: "微软雅黑", "黑体", "宋体";
		font-size: 14px;
		margin: 0px;
		padding: 0px;
	}

	html,
	body {
		height: 100%;
		width: 100%;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		background: #F3F3F3;
	}

	body img {
		vertical-align: middle;
		border: 0;
		outline: none;
	}

	address,
	caption,
	cite,
	code,
	dfn,
	em,
	strong,
	th,
	var {
		font-style: normal;
		font-weight: normal;
	}

	a {
		text-decoration: none;
	}

	input::-ms-clear {
		display: none;
	}

	input::-ms-reveal {
		display: none;
	}

	input {
		-webkit-appearance: none;
		margin: 0;
		outline: none;
		padding: 0;
	}

	input::-webkit-input-placeholder {
		color: #ccc;
	}

	input::-ms-input-placeholder {
		color: #ccc;
	}

	input::-moz-placeholder {
		color: #ccc;
	}

	input[type=submit],
	input[type=button] {
		cursor: pointer;
	}

	button[disabled],
	input[disabled] {
		cursor: default;
	}

	img {
		border: none;
	}

	ul,
	ol,
	li {
		list-style-type: none;
	}

	.el-button--primary {
		height: 30px;
		line-height: 30px;
		min-height: auto;
		padding: 0px 15px;
		background: #5386E2;
	}

	.el-button--primary:hover {
		background: #5386E2;
		opacity: 0.9;
	}
	.el-button--primary:active {
		background: #5386E2;
		opacity: 0.9;
	}
</style>
